import React, { useEffect, useState } from "react";
import backgroundSrc from "../assets/bg.jpg"
import "./BlogPage.scss"
import BlogItem from "../components/BlogItem/BlogItem";
import BlogInput from "../components/BlogInput/BlogInput";
import BlogDropdown from "../components/BlogDropdown/BlogDropdown";
import BlogPagination from "../components/BlogPagination/BlogPagination";
import { getAllBlogPosts } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../helper/helper";
const BlogPage = () => {
    const [searchKey, setSearchKey] = useState("")
    const sortOptions = [
        { label: "All Blogs", value: "all" },
        { label: "Newest", value: "newest" },
        { label: "Oldest", value: "oldest" },
    ];
    const catOptions = [
        { label: "All Categories", value: "all" },
    ];
    const [sort, setSort] = useState(sortOptions[0])
    const [category, setCategory] = useState(catOptions[0])
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "blog")
    const Components = page?.Components || []


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        fetchData()
    }, [])
    const fetchData = async () => {
        setIsLoading(true)
        let id = companyDetails?.ID ?? ''
        await getAllBlogPosts(id).then((response) => {
            if (response.data) {
                setData(response.data)
                setTotalItems(response?.data?.length)
            } else {
                setData([])
                setTotalItems(0)
            }
            setIsLoading(false)

        })
    }
    const [totalItems, setTotalItems] = useState(data.length);
    const itemsPerPage = 12
    const [currentPage, setCurrentPage] = useState(1);
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatBlogPage-hero-header":
                return <div className="BlogPage-hero-header-cont">
                    <div className="BlogPage-hero-header">{component?.Props?.header}</div>
                    <div className="BlogPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="BlogPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="BlogPage-hero-container">
                    <div className="BlogPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}

                    </div>
                </div>
            </div>
        )
    }
    const containerComponent = () => {
        return <div className="BlogPage-wrapper">
            {isLoading ? <div className="loader-blog " /> :
                data?.length > 0 && <div className="BlogPage-wrapper-container">
                    <div className="BlogPage-wrapper-container-filter">
                        <BlogInput
                            value={searchKey}
                            setValue={setSearchKey} />
                        <BlogDropdown
                            selected={category}
                            setSelected={setCategory}
                            items={catOptions}
                            showSortText={false}
                        />
                        <BlogDropdown
                            selected={sort}
                            setSelected={setSort}
                            items={sortOptions}
                        />
                    </div>
                    <div className="BlogPage-wrapper-container-grid">
                        {data?.length > 0 && data?.map((item, key) => {
                            return (
                                <BlogItem
                                    item={item}
                                    key={key}
                                    isHome={false} />

                            )
                        })
                        }
                    </div>
                    {data?.length > 0 && <div className="BlogPage-wrapper-container-pagination">
                        <BlogPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            onPageChange={(e) => {
                                setCurrentPage(e)
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });


                            }} />
                    </div>}
                </div>}
        </div>
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatBlogPage-hero":
                return headerComponent(component)
            case "VirasatBlogPage-container":
                return containerComponent()
            default:
                return <div />
        }

    }
    return (
        <div className="BlogPage">
            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}

        </div>
    )
}
export default BlogPage